import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }

import { ref } from "vue";
import { AdminApi, CreateUpdatePersonRequest, MedicalPersonLightResponse } from '@/apiGenerate/medserver';
import EsPersonForm from "@/components/form/esPersonForm.vue";
import { ApiError, MedicalPersonRoleStatus } from "@/models/share.model";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue";
import { medServerApiConfig } from "@/config/medserver-api.config";


export default /*@__PURE__*/_defineComponent({
  __name: 'esMedicalPersonForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    currentMedicalPerson: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {t} = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);

const personRoleTypes = ref<string[]>(Object.values(MedicalPersonRoleStatus) as string[]);
const initForm = ref<boolean>(false);

const emits = __emit;


const confirmPersonForm = (createUpdatePersonRequest: CreateUpdatePersonRequest) => {
  if (!createUpdatePersonRequest) {
    emits('modal-close', false);
    return;
  }

  if(props.currentMedicalPerson) {
    adminApi.updateMedicalPerson({personId: props.currentMedicalPerson.personId, createUpdatePersonRequest: createUpdatePersonRequest}).then(() => {
          toastSuccess(toast, {
              summary: t('common.toast.success.update'),
              detail:  t('admin.medicalPerson.form.message.success.update')
          });
          initForm.value = true;
          emits("modal-close", true);
      }).catch((error: ApiError) => {
          initForm.value = false;
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
    });
  } else {
      adminApi.addMedicalPerson({createUpdatePersonRequest: createUpdatePersonRequest}).then(() => {
          toastSuccess(toast, {
              summary: t('common.toast.success.add'),
              detail:  t('admin.medicalPerson.form.message.success.add')
          });
          initForm.value = true;
          emits("modal-close", true);
      }).catch((error: ApiError) => {
          initForm.value = false;
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  } 
}

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(EsPersonForm, {
                personRoleTypes: personRoleTypes.value,
                "current-medical-person": _ctx.currentMedicalPerson,
                cancelCloseModal: true,
                "init-form": initForm.value,
                onConfirmForm: _cache[0] || (_cache[0] = ($event: any) => (confirmPersonForm($event))),
                onUpdateInitForm: _cache[1] || (_cache[1] = ($event: any) => (initForm.value = false))
              }, null, 8, ["personRoleTypes", "current-medical-person", "init-form"])
            ])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})